<template>
  <span>
      <template v-if="isDesktop">
              <div v-if="mixedContentData.videoFileDesktop && mixedContentData.videoFileDesktop.src != ''"  class="video-block has-aspect-ratio is-1by1-desktop is-1by1-mobile" v-lazy-load-video>		
                  <video-block :video-data="mixedContentData.videoFileDesktop"></video-block>
              </div>
              <template v-else>
                  <picture-block v-if="mixedContentData.pictureFile" :picture-data="mixedContentData.pictureFile"></picture-block>
              </template>
      </template>
      <template v-else>
          <div v-if="mixedContentData.videoFileMobile && mixedContentData.videoFileMobile.src != ''" class="video-block has-aspect-ratio is-1by1-desktop is-1by1-mobile" v-lazy-load-video>	
              <video-block  :video-data="mixedContentData.videoFileMobile"></video-block>
          </div>
          <template v-else>
              <picture-block  v-if="mixedContentData.pictureFile" :picture-data="mixedContentData.pictureFile"></picture-block>
          </template>
      </template>
  </span>
</template>
<script>
export default {
  name:"mixed-content-slider",
  data() {
      return {
          isDesktop: window.matchMedia('(min-width: 64rem)').matches,
      };
  },
  props: {
      mixedContentData :{
          type: Object,
      }
  }
}
</script>